import { Column, Columns, Inline } from 'braid-design-system';
import type { FC } from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import { MoveStatusMenu } from './MoveStatusMenu';
import { NotSuitableAndShortlistButtons } from './NotSuitableAndShortlistButtons';

interface ChangeStatusButtonsProps {
  jobApplication: {
    id: string;
    fullName: string;
    bucket: BUCKETS;
  };
  changeStatus: (bucket: BUCKETS) => Promise<void>;
}

export const ChangeStatusButtons: FC<ChangeStatusButtonsProps> = ({
  jobApplication: { id, fullName, bucket },
  changeStatus,
}) =>
  bucket === BUCKETS.INBOX ? (
    <Columns space="small" alignY="center">
      <Column width="content">
        <NotSuitableAndShortlistButtons
          idPrefix={id}
          fullName={fullName}
          changeStatus={changeStatus}
        />
      </Column>
      <Column>
        <Inline space="none">
          <MoveStatusMenu
            currentBucket={bucket}
            fullName={fullName}
            changeStatus={changeStatus}
          />
        </Inline>
      </Column>
    </Columns>
  ) : (
    <MoveStatusMenu
      currentBucket={bucket}
      fullName={fullName}
      changeStatus={changeStatus}
    />
  );
